define('model/template.model',['require','exports','module','fukit'],function(require, exports, module) {
  var Base = require('fukit').BaseModel;

  var Template = Base.extend({
    radioRequests: {
      'models Template': '@constructor',
    },

    urlRoot: '/api/v1/eform/template',

    childModels: {
      templateType: 'TemplateType',
    },
  });
  module.exports = Template;
});

